module.exports = __webpack_public_path__ + "static/media/fk-vitebsk-wb.35f81aba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/fk-vitebsk-wb.svg
// module id = 527
// module chunks = 0